import React, { useContext, useState } from 'react';
import { compose } from 'redux';

import Popup from 'shared/components/Popup';
import connectProps from 'shared/lib/connectProps';
import SettingsContext from 'shared/lib/SettingsContext';

const ClientsPreviewButton = (props) => {

  const settings = useContext(SettingsContext) || {}

  const [popup_viewely, setPopupViewely] = useState(false)

  const popupViewely = () => {
    setPopupViewely(true)
  }

  return (
    <div className="powerful-clients__preview-button">
      {!popup_viewely &&
        <Popup after={() => {popupViewely()}}>
          <p></p>
          <p>{ i18n.t('header.clients_preview_instruction') }</p>
          { settings.testing_page_info_url &&
            <a href={settings.testing_page_info_url} target="_blank">{ i18n.t('header.clients_preview_more') }</a>
          }
        </Popup>
      }
      <button disabled={settings.disabled} className="btn btn-form btn-with-icon" onClick={() => window.etLoader.show(settings.id, settings.next_url)}>
        <i className="fi fi-check"></i>
        { i18n.t('header.clients_preview') }
      </button>
    </div>
  );
}

export default ClientsPreviewButton;
